<template>
  <div>
    <ui-button
      :color="buttonColor"
      :disabled="isIntegrationDisabled"
      :loading="isLoading"
      @click="isDirectToggleDisabled ? toggleDialog() : toggleIntegration()"
    >
      {{ buttonLabel }}
    </ui-button>
    <ToggleDialog
      v-if="showDialog"
      :integration-type="integrationType"
      :is-enabling="!isEnabled"
      @close="showDialog = false"
      @toggle="toggleIntegration"
    />
  </div>
</template>

<script>
import mapIntegrationsService from "@/services/mapIntegrations.js";
import serviceHandler from "@/helpers/handlers/service";
const MAP_DISABLED_INTEGRATION_LIST = ["google"];
const MAP_ALERT_INTEGRATION_LIST = ["bing"];
export default {
  name: "ToggleButton",
  components: {
    ToggleDialog: () =>
      import("@/components/BusinessAddresses/ToggleDialog.vue")
  },
  props: {
    isEnabled: {
      type: Boolean,
      default: false
    },
    integrationType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showDialog: false,
      isLoading: false
    };
  },
  computed: {
    buttonLabel() {
      const currentState = this.isEnabled ? "disable" : "enable";
      return this.$t(`message.mapIntegrations.${currentState}`);
    },
    buttonColor() {
      return !this.isEnabled ? "primary" : "default";
    },
    isIntegrationDisabled() {
      return MAP_DISABLED_INTEGRATION_LIST.includes(this.integrationType);
    },
    isDirectToggleDisabled() {
      return MAP_ALERT_INTEGRATION_LIST.includes(this.integrationType);
    },
    integrationPayload() {
      return {
        [this.integrationType]: {
          is_enabled: !this.isEnabled
        }
      };
    }
  },
  methods: {
    async toggleIntegration() {
      this.showDialog = false;
      this.isLoading = true;
      await serviceHandler(
        mapIntegrationsService.toggleMapIntegration(this.integrationPayload)
      );
      this.isLoading = false;
      this.$emit("get-integrations");
    },
    toggleDialog() {
      this.showDialog = !this.showDialog;
    }
  }
};
</script>
